import * as message from '../actions/message.actions';
import { AppMessage } from '../model/app-message.model';

/**
 * Handles application messages.
 */
export function messages(state: AppMessage[] = [], action: message.Actions): AppMessage[] {
    switch (action.type) {
        case message.MESSAGE_SHOW:
            return [...state, action.payload];
        case message.MESSAGE_HIDE:
            return state.filter(msg => msg.id !== action.payload);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/reducers/messages.reducer.ts